export const resultsCopy = {
  it: {
    back: "Torna a SYNrise",
    kicker: "Community",
    title: ["Risultati e", "testimonianze"],
    sub: "Screenshot e testimonianze condivisi dalle community SYNrise, Be Five% e RiseVision.",
    note: "I risultati mostrati sono individuali, non sono indicativi né garantiscono risultati futuri. Gli investimenti comportano rischi.",
    tabs: { all: "Tutti", result: "Risultati", testimonial: "Testimonianze" },
    empty: "Ancora nessun contenuto pubblicato. Torna presto!",
    add: "Aggiungi",
    signedAs: "Admin",
    logout: "Esci",
    login: { title: "Accesso admin", sub: "Solo gli admin SYNrise possono pubblicare contenuti.", submit: "Accedi" },
    upload: {
      title: "Aggiungi contenuti",
      kind: "Tipo",
      choose: "Scegli una o più immagini",
      change: "Cambia immagini",
      caption: "Didascalia (facoltativa)",
      author: "Nome / autore (facoltativo)",
      submit: "Pubblica",
      uploading: "Caricamento",
      done: "Contenuti pubblicati",
      tooBig: "Alcuni file superano 10 MB e sono stati esclusi",
      failed: "Caricamento non riuscito",
    },
    del: { title: "Eliminare questo contenuto?", sub: "Sparirà dalla galleria per tutti.", ok: "Elimina", cancel: "Annulla", done: "Contenuto eliminato" },
  },
  en: {
    back: "Back to SYNrise",
    kicker: "Community",
    title: ["Results &", "testimonials"],
    sub: "Screenshots and testimonials shared by the SYNrise, Be Five% and RiseVision communities.",
    note: "Results shown are individual and are not indicative of, nor do they guarantee, future results. Investing involves risk.",
    tabs: { all: "All", result: "Results", testimonial: "Testimonials" },
    empty: "Nothing published yet. Check back soon!",
    add: "Add",
    signedAs: "Admin",
    logout: "Log out",
    login: { title: "Admin access", sub: "Only SYNrise admins can publish content.", submit: "Sign in" },
    upload: {
      title: "Add content",
      kind: "Type",
      choose: "Choose one or more images",
      change: "Change images",
      caption: "Caption (optional)",
      author: "Name / author (optional)",
      submit: "Publish",
      uploading: "Uploading",
      done: "Content published",
      tooBig: "Some files exceed 10 MB and were skipped",
      failed: "Upload failed",
    },
    del: { title: "Delete this item?", sub: "It will disappear from the gallery for everyone.", ok: "Delete", cancel: "Cancel", done: "Item deleted" },
  },
  es: {
    back: "Volver a SYNrise",
    kicker: "Comunidad",
    title: ["Resultados y", "testimonios"],
    sub: "Capturas y testimonios compartidos por las comunidades SYNrise, Be Five% y RiseVision.",
    note: "Los resultados mostrados son individuales, no son indicativos ni garantizan resultados futuros. Invertir conlleva riesgos.",
    tabs: { all: "Todos", result: "Resultados", testimonial: "Testimonios" },
    empty: "Aún no hay contenido publicado. ¡Vuelve pronto!",
    add: "Añadir",
    signedAs: "Admin",
    logout: "Salir",
    login: { title: "Acceso admin", sub: "Solo los admins de SYNrise pueden publicar contenido.", submit: "Entrar" },
    upload: {
      title: "Añadir contenido",
      kind: "Tipo",
      choose: "Elige una o varias imágenes",
      change: "Cambiar imágenes",
      caption: "Descripción (opcional)",
      author: "Nombre / autor (opcional)",
      submit: "Publicar",
      uploading: "Subiendo",
      done: "Contenido publicado",
      tooBig: "Algunos archivos superan 10 MB y se han omitido",
      failed: "Error al subir",
    },
    del: { title: "¿Eliminar este contenido?", sub: "Desaparecerá de la galería para todos.", ok: "Eliminar", cancel: "Cancelar", done: "Contenido eliminado" },
  },
};
